import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs/Observable';
import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid/dist/lib/entities/gridOptions';

@Injectable()
export class FleetService {
  constructor(
    private apiService:ApiService,
  ) {}

  getAllVesselList(): Observable<any> {
    return this.apiService.get('/vessels');
  }

  getFleetList(): Observable<any> {
    return this.apiService.get('admin/tracking/fleets');
  }

  getVesselList(fleetId): Observable<any> {
    return this.apiService.get('admin/tracking/fleets/' + fleetId + '/vessels');
  }

  postFleets(body: Fleet[]) {
    return this.apiService.post('admin/tracking/fleets', { 'aisFleetList': body }, true);
  }

  postVessel(body: FleetVessel[], fleetId) {
    return this.apiService.post('admin/tracking/fleets/' + fleetId + '/vessels', { 'aisVesselList': body }, true);
  }

  deleteFleet(fleetId) {
    return this.apiService.delReqParamsType('/admin/tracking/fleets/' + fleetId);
  }

}

export class Fleet {
  updUser?: FleetUser;
  insUser?: FleetUser;
  aisFleetId?: number;
  fleetId?: string;
  name: string;
  description: string;
  status?: string;
  insDtm?: string;
  insUserId?: number;
  updDtm?: string;
  updUserId?: number;
  regDtm?: string;
  delDtm?: string;
}

export class FleetUser {
  userId: number;
  email: string;
  lastNm: string;
  firstNm: string;
}

export class FleetVessel {
    vesselList: FleetVesselList[];
    updUser: number;
    insUser: number;
    mmsi: string;
    aisFleetId: number;
    imoNo: string;
    typeCd: string;
    typeDesc: string;
    status: string;
    insDtm: string;
    insUserId: number;
    updDtm: string;
    updUserId: number;
    regDtm: string;
    delDtm: string;
}

export class FleetVesselList {
  vesselId: number;
  vesselNm: string;
  imoNo: string;
  mmsi: string;
  callSign: string;
}

export class VesselShort {
  imoNo: string;
  mmsi: string;
  operCd: string;
  vesselId: number;
  vesselNm: string;
}


// WEBPACK FOOTER //
// ./src/app/services/fleet.service.ts